import React, { useEffect, useMemo, useRef, useState } from "react"
import { CURRENCIES } from "../lib/currencies"
import { cn } from "../lib/utils"

const INPUT_HEIGHT =
  "h-9 w-full rounded-lg border border-input bg-card px-2.5 text-sm text-foreground outline-none transition-shadow focus:border-primary focus:ring-2 focus:ring-ring/20"

export function CurrencySearchSelect({ label, value, onChange, error }) {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState("")
  const rootRef = useRef(null)

  const selected = CURRENCIES.find((c) => c.code === value) || CURRENCIES[0]

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return CURRENCIES
    return CURRENCIES.filter(
      (c) =>
        c.code.toLowerCase().includes(q) ||
        c.name.toLowerCase().includes(q) ||
        c.symbol.toLowerCase().includes(q),
    )
  }, [query])

  useEffect(() => {
    function onDocClick(e) {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener("mousedown", onDocClick)
    return () => document.removeEventListener("mousedown", onDocClick)
  }, [])

  return (
    <label className="grid gap-0.5 text-xs" ref={rootRef}>
      <span className="text-muted-foreground">{label}</span>
      <div className="relative">
        <button
          type="button"
          className={cn(INPUT_HEIGHT, "flex items-center justify-between text-left")}
          onClick={() => {
            setOpen((v) => !v)
            setQuery("")
          }}
        >
          <span>
            {selected.code} — {selected.name} ({selected.symbol})
          </span>
          <span className="text-muted-foreground">▾</span>
        </button>
        {open ? (
          <div className="absolute z-30 mt-1 w-full rounded-lg border border-border bg-card shadow-lg">
            <div className="border-b border-border p-2">
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search currency…"
                className={INPUT_HEIGHT}
                autoFocus
              />
            </div>
            <ul className="max-h-48 overflow-y-auto py-1 text-sm">
              {filtered.map((c) => (
                <li key={c.code}>
                  <button
                    type="button"
                    className={cn(
                      "flex w-full items-center gap-2 px-3 py-2 text-left hover:bg-muted/60",
                      c.code === value && "bg-primary/10 font-medium text-primary",
                    )}
                    onClick={() => {
                      onChange(c.code)
                      setOpen(false)
                      setQuery("")
                    }}
                  >
                    <span className="w-10 font-mono text-xs">{c.code}</span>
                    <span className="flex-1">{c.name}</span>
                    <span className="text-muted-foreground">{c.symbol}</span>
                  </button>
                </li>
              ))}
              {filtered.length === 0 ? (
                <li className="px-3 py-2 text-muted-foreground">No currencies match</li>
              ) : null}
            </ul>
          </div>
        ) : null}
      </div>
      {error ? <span className="text-[12px] text-red-600">{error}</span> : null}
    </label>
  )
}

export { INPUT_HEIGHT as FORM_INPUT_CLASS }
